const craftableLevels = [
  '1',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
  '24',
  '26',
  '28',
  '30',
  '32',
  '34',
  '36',
  '38',
  '40',
  '42',
  '44',
  '46',
  '48',
  '50',
  'CP 10',
  'CP 20',
  'CP 30',
  'CP 40',
  'CP 50',
  'CP 60',
  'CP 70',
  'CP 80',
  'CP 90',
  'CP 100',
  'CP 110',
  'CP 120',
  'CP 130',
  'CP 140',
  'CP 150',
  'CP 160',
];

export default craftableLevels;
